import cx from "classnames";
import { CSSProperties, forwardRef, HTMLAttributes, memo, ReactNode } from "react";

import styles from "./styles.module.css";

type TableBodyRowProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  isActive?: boolean;
  isGroupOpen?: boolean;
  /** Row inside an expanded group: indents the first cell and draws the group guide line. */
  isGroupChild?: boolean;
  dataIndex?: number;
  virtualized?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const TableBodyRow = forwardRef<HTMLDivElement, TableBodyRowProps>(function TableBodyRow(
  { children, className, isActive, isGroupOpen, isGroupChild, dataIndex, virtualized, ...props },
  ref
) {
  return (
    <div
      {...props}
      className={cx(styles.row, className, {
        [styles.active]: isActive,
        [styles.groupOpen]: isGroupOpen,
        [styles.groupChild]: isGroupChild,
        [styles.virtualized]: virtualized,
      })}
      role="row"
      tabIndex={-1}
      ref={ref}
      data-index={dataIndex}
    >
      {children}
    </div>
  );
});

TableBodyRow.displayName = "DS.Table.Body.Row";

export default memo(TableBodyRow);
